import { Box, Button, Collapse, Flex, Stack, useDisclosure } from '@chakra-ui/react';
import { faAngleDown, faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface IFingerExpander {
  id: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  isExpandable?: boolean;
  children?: React.ReactNode;
  flag?: React.ReactNode;
  alert?: React.ReactNode;
}

export const FingerExpander = (props: IFingerExpander) => {
  const { id, label, icon, children, flag, alert } = props;

  const { onToggle, isOpen } = useDisclosure();

  const getClickableProps = () => {
    if (children) {
      return {
        'data-selector': `${id}-metadata-switch`,
        as: Button,
        variant: 'unstyled',
        onClick: onToggle,
        _hover: { bgColor: 'hover-bg' },
        _focusVisible: { bgColor: 'hover-bg' },
      };
    }
    return null;
  };

  return (
    <Stack spacing={0} data-selector={`${id}-finger-section`}>
      <Flex>
        <Box width={{ md: 10 }}>{icon}</Box>

        <Flex
          py={2}
          pl={1}
          pr={3}
          borderRadius={'lg'}
          flexGrow={0}
          whiteSpace={'normal'}
          flexShrink={1}
          textAlign={'left'}
          height={'auto'}
          alignItems={'start'}
          {...getClickableProps()}
        >
          <Flex width={7} alignItems={'center'} py={0.5}>
            {children && (
              <FontAwesomeIcon
                icon={isOpen ? faAngleDown : faAngleRight}
                size="lg"
                className="utility-icon"
                fixedWidth
              />
            )}
          </Flex>

          <Box id={`${id}-label`} data-selector={`${id}-label`} fontSize={'lg'} lineHeight={6} fontWeight={'medium'}>
            {label}

            {flag}
          </Box>
        </Flex>
      </Flex>

      {children && (
        <Collapse in={isOpen}>
          <Box data-selector={`${id}-description`} ml={10}>
            {alert}

            {children && <Box my={3}>{children}</Box>}
          </Box>
        </Collapse>
      )}
    </Stack>
  );
};
